import { render, staticRenderFns } from "./RenewalModal.vue?vue&type=template&id=4906bc2c"
import script from "./RenewalModal.vue?vue&type=script&lang=ts"
export * from "./RenewalModal.vue?vue&type=script&lang=ts"
import style0 from "./RenewalModal.vue?vue&type=style&index=0&id=4906bc2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports